// client/src/components/shared/SearchFilterBar.jsx
// Reusable search + date-range filter bar for list views

import React from "react";

const barStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  marginBottom: 12,
};

// Desktop horizontal layout is handled via .search-filter-bar in desktop.css

const inputStyle = {
  background: "#2a2a2a",
  color: "#fff",
  border: "1px solid #555",
  borderRadius: 6,
  padding: "6px 10px",
  fontSize: "0.85rem",
  width: "100%",
  minWidth: 0,
};

const dateRowStyle = {
  display: "flex",
  gap: 8,
  alignItems: "center",
};

const dateInputStyle = {
  background: "#2a2a2a",
  color: "#fff",
  border: "1px solid #555",
  borderRadius: 6,
  padding: "6px 10px",
  fontSize: "0.85rem",
  width: "100%",
  minWidth: 0,
};

const dateLabelStyle = {
  display: "block",
  fontSize: "0.7rem",
  color: "#aaa",
  marginBottom: 2,
};

const clearBtnStyle = {
  background: "none",
  border: "1px solid #ffa500",
  color: "#ffa500",
  borderRadius: 6,
  padding: "6px 12px",
  fontSize: "0.8rem",
  cursor: "pointer",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

export default function SearchFilterBar({
  searchTerm,
  onSearchChange,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  onClear,
  showDateFilter = true,
  searchPlaceholder = "Search\u2026",
}) {
  const hasFilters = searchTerm || dateFrom || dateTo;

  return (
    <div className="search-filter-bar" style={barStyle}>
      <div className="search-filter-bar__search" style={{ flex: "1 1 0", minWidth: 0 }}>
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          style={inputStyle}
        />
      </div>
      {showDateFilter && (
        <div className="search-filter-bar__dates" style={dateRowStyle}>
          <div style={{ flex: "1 1 0", minWidth: 0 }}>
            <label htmlFor="sfb-date-from" style={dateLabelStyle}>Start Date</label>
            <input
              id="sfb-date-from"
              type="date"
              value={dateFrom}
              onChange={(e) => onDateFromChange(e.target.value)}
              style={dateInputStyle}
              title="From date"
            />
          </div>
          <div style={{ flex: "1 1 0", minWidth: 0 }}>
            <label htmlFor="sfb-date-to" style={dateLabelStyle}>End Date</label>
            <input
              id="sfb-date-to"
              type="date"
              value={dateTo}
              onChange={(e) => onDateToChange(e.target.value)}
              style={dateInputStyle}
              title="To date"
            />
          </div>
          {hasFilters && (
            <button type="button" onClick={onClear} style={clearBtnStyle}>
              Clear
            </button>
          )}
        </div>
      )}
      {!showDateFilter && hasFilters && (
        <button type="button" onClick={onClear} style={clearBtnStyle}>
          Clear
        </button>
      )}
    </div>
  );
}
